import { Grid, Typography, useMediaQuery, TextField, Button } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import React from 'react';
import { useAppDispatch, useAppSelector } from '../reduxhooks';

import "react-step-progress-bar/styles.css";
import axios from 'axios';

import { socket } from '../socket';
import { sendWebsiteLivestreamMessage } from '../telegrambotevents';
import OverlayComponentCanvasFitAnimationMeasurer from './PageVisualAlignerCanvasAnimation';
import { BodyMeasurementsForSize, CalculateClothingMeasurementsFromBodyMeasurements, 
  ClothingType, FitType, RoundClothingMeasurementsToHalfPoint } from 'common-ts/dist/models/UserMeasurements';
import { RegularSizeValue } from 'common-ts/dist/models/Cart';


const useStyles = makeStyles((theme: Theme) =>
createStyles({
  fullHeight: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '100px',
    },
  },
  titleLogoContainer: {
    height: '42px',
    marginTop: '34px',
    marginBottom: '10px',
  },
  titleLogo: {
    height: '24px',
    display: 'block', // We use block so that the img is unique horizontally in the div
    marginLeft: '40px',
  },
  checkoutFormContainer: {
    height: 'auto',
    width: '100%',
  },
  sideCartList: {
    display: 'none',
    height: '100vh',
    background: '#fafafa',
    width: '480px',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      height: 'auto',
    },
  },
  sideCartListInner: {
    background: '#fafafa',
    width: '432px',
    padding: '24px',
  },
  cartMainSegment: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 'calc(100% - 480px)',
    },
  },
  cartMobile: {
    width: 'calc(100%-48px)',
    padding: '16px 24px 26px 24px',
    backgroundColor: '#fafafa',
  },
  cartMobileAccordion: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '18px',
    backgroundColor: '#fafafa',
    '&:active': {
      backgroundColor: '#eaeaea',
    }
  },
  cartMobileAccordionIcon: {
    marginRight: '12px',
    color: '#222',
  },
  cartMobileAccordionText: {
    fontSize: '13px',
    fontWeight: 400,
    color: '#222',
  },
  cartMobileAccordionIconOpenClose: {
    marginLeft: '4px',
    color: '#222',
  },
  cartMobileAccordionPrice: {
    color: '#222',
    fontSize: '14px',
    fontFamily: 'Open Sans, sans-serif',
  },
  cartMobileText: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  cartMobileContainer: {
    width: '100%',
  },
  nextStepButtonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    marginTop: '16px',
  },
  nextStepButton: {
    marginRight: '20px',
    marginLeft: 'auto',
  },
  orderSpacer: {
    [theme.breakpoints.down('sm')]: {
      width: "100px",
      height: "30px",
    },
  },
  countdownComponent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  countdownMainText: {
    fontSize: "20px",
    fontWeight: 500,
    paddingTop: "8px",
    paddingBottom: "10px",
  },
  countdownMainTextTimeout: {
    fontSize: "24px",
    fontWeight: 500,
    paddingTop: "8px",
    paddingBottom: "16px",
  },
  countdownNumberText: {
    fontSize: "22px",
    fontWeight: 300,
    letterSpacing: "1.2px",
    fontFamily: 'Open Sans, sans-serif',
    paddingBottom: "22px",
    color: "#343434",
  },
  countdownSubTextHighlight: {
    fontSize: "12px",
    fontWeight: 500,
    color: "#000000",
  },
  countdownSubText: {
    fontSize: "12px",
    fontWeight: 300,
    color: "#343434",
    paddingBottom: "42px",
    textAlign: "center",
  },
  countdownSubTextTimeout: {
    fontSize: "12px",
    fontWeight: 300,
    color: "#343434",
    paddingBottom: "4px",
    paddingTop: "4px",
    textAlign: "center",
  },
  countdownButtonText: {
    fontSize: "12px",
    letterSpacing: "0.7px",
    fontWeight: 500,
  },
  orderTrackerContainer: {
    padding: "0px 32px",
  },
  orderTrackerMainText: {
    fontSize: "20px",
    fontWeight: 500,
    paddingBottom: "2px",
  },
  orderTrackerSubText: {
    fontSize: "12px",
    fontWeight: 300,
    color: "#343434",
    letterSpacing: "0.6px",
  },
  orderTrackerImageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingRight: "5px",
  },
  orderTrackerImage: {
    height: "100px",
    paddingTop: "15px",
    paddingBottom: "12px",
  },
  orderTrackerImageText: {
    fontSize: "18px",
    fontWeight: 600,
    paddingBottom: "21px",
  },
  estimasiPengirimanMainText: {
    fontSize: "12px",
    fontWeight: 500,
    paddingBottom: "2px",
    letterSpacing: "0.4px",
  },
  estimasiPengirimanSubText: {
    fontSize: "10px",
    fontWeight: 300,
    paddingBottom: "22px",
    letterSpacing: "0.7px",
  },
  orderProgressBarContainer: {
    marginTop: "30px",
    marginBottom: "20px",
    paddingLeft: "40px",
    paddingRight: "40px",
    paddingTop: "50px",
    paddingBottom: "80px",
  },
  orderProgressBarPointGreened: {
    width: "35px",
    height: "35px",
    borderRadius: "104px",
    backgroundColor: "#30ac0a",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  orderProgressBarPointGreyed: {
    width: "35px",
    height: "35px",
    borderRadius: "104px",
    backgroundColor: "#B9B9B9",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  orderProgressBarPoint: {
    width: "35px",
    height: "35px",
    borderRadius: "104px",
    backgroundColor: "#1c1c1c",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  orderProgressBarText: {
    textAlign: "center",
    width: "35px",
    paddingTop: "8.5px",
    fontSize: "13px",
    fontWeight: 400,
    color: "#ffffff"
  },
  orderProgressBarDoneIcon: {
    color: "#ffffff",
    paddingTop: "6px",
    width: "22px",
    height: "22px"
  },
  orderProgressPointImageIcon: {
    position: "absolute",
    top: "-60px",
  },
  orderProgressPointDescription: {
    fontSize: "10px",
    fontWeight: 300,
    textAlign: "center",
    position: "absolute",
    top: "46px",
  },
  pengirimanTrackerMainText: {
    fontSize: "20px",
    fontWeight: 600,
    letterSpacing: "0.8px",
    paddingBottom: "2px",
    marginTop: "14px",
  },
  pengirimanTrackerSubBoldText: {
    fontSize: "13px",
    fontWeight: 600,
    letterSpacing: "0.5px",
    color: "#232323",
    marginTop: "16px",
  },
  pengirimanTrackerSubLightText: {
    fontSize: "12px",
    letterSpacing: "0.3px",
    fontWeight: 300,
    color: "#454545",
    marginTop: "3px"
  },
  pengirimanTrackerHistory: {
    fontSize: "19px",
    fontWeight: 500,
    letterSpacing: "0.6px",
    paddingBottom: "2px",
    marginTop: "27px",
    marginBottom: "9px",
  },
  pengirimanTrackerHistorySubText: {
    fontSize: "13px",
    letterSpacing: "0.3px",
    fontWeight: 500,
    color: "#343434",
    paddingTop: "5.5px",
    marginLeft: "12px"
  },
  pengirimanTrackerHistorySubTextTime: {
    fontSize: "12px",
    letterSpacing: "0.3px",
    fontWeight: 300,
    color: "#676767",
    paddingTop: "3.5px",
    marginLeft: "12px"
  }
}),
);

export default function PageOrder() {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));
  const [barcodeScan, setBarcodeScan] = React.useState<string>('');
  const [scaleRatioNumber, setScaleRatioNumber] = React.useState<number>(Number(localStorage?.getItem("scaleRatioNumber") ? localStorage.getItem("scaleRatioNumber") : '1000'));
  const [aspectRatioNumber, setAspectRatioNumber] = React.useState<number>(Number(localStorage?.getItem("aspectRatioNumber") ? localStorage.getItem("aspectRatioNumber") : '1000'));
  const [selectedOrderObject, setSelectedOrderObject] = React.useState<any>(null);
  const [selectedOrderItemMeasurementObject, setSelectedOrderItemMeasurementObject] = React.useState<any>(null);

  return (
    <Box style={{
      height: '99vh',
      overflow: 'scroll',
      position: 'relative',
      width: '100%',
    }}>
      <TextField 
      style={{
        marginLeft: '15px',
      }}
        margin="dense"
        id="barcodeScan"
        name="barcodeScan"
        label="Barcode Produk"
        type="text"
        value={barcodeScan}
        error={false}
        onChange={(e) => {
          const candidateString = String(e.target.value);
          setBarcodeScan(candidateString);

          if (candidateString.includes("H8L") || candidateString.includes("H8R") || candidateString.includes("H8X")) {
            const cleanString = candidateString.substring(0, candidateString.length - 3);
            setSelectedOrderObject(null);
            setSelectedOrderItemMeasurementObject(null);

            // GET ORDER ID FROM THE CLEAN STRING
            axios({
              method: 'post',
              url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/order', // Endpoint for order update
              data: JSON.stringify({
                itemOrderCodeToOrderId: cleanString,
              })
            }).then((response) => {
              const itemNumber = response?.data?.itemNumber;
              const orderObject = response?.data?.orderObject;

              let measurementObject = null;
              let counter = 0;
              for (let i = 0; i < orderObject.cartProductList.length; i++) {
                const cartProductItem = orderObject.cartProductList[i];
                for (let j = 0; j < cartProductItem.amount; j++) {
                  if (counter === itemNumber) {
                    measurementObject = cartProductItem;
                  }

                  counter++;
                }
              }

              setSelectedOrderObject(orderObject);
              setSelectedOrderItemMeasurementObject(measurementObject);
            });

            setBarcodeScan('');
          }
        }}
        InputLabelProps={{
          shrink: true,
        }}/>
      <TextField 
      style={{
        marginLeft: '15px',
      }}
        margin="dense"
        id="scaleRatio"
        name="scaleRatio"
        label="Zoom Setting"
        type="number"
        value={scaleRatioNumber}
        error={false}
        onChange={(e) => {
          setScaleRatioNumber(Number(e?.target?.value));
          localStorage.setItem("scaleRatioNumber", JSON.stringify(Number(e?.target?.value)));
        }}
        InputLabelProps={{
          shrink: true,
        }}/>
      <TextField 
      style={{
        marginLeft: '15px',
      }}
        margin="dense"
        id="aspectRatio"
        name="aspectRatio"
        label="Y to X Ratio Setting"
        type="number"
        value={aspectRatioNumber}
        error={false}
        onChange={(e) => {
          setAspectRatioNumber(Number(e?.target?.value));
          localStorage.setItem("aspectRatioNumber", JSON.stringify(Number(e?.target?.value)));
        }}
        InputLabelProps={{
          shrink: true,
        }}/>
      <Typography style={{fontSize: '14px', margin: '14px'}}><b>{selectedOrderObject?.orderName ? selectedOrderObject.orderName : '-'}: </b>{selectedOrderItemMeasurementObject?.clothingType} - {selectedOrderItemMeasurementObject?.fitType}</Typography>
      <OverlayComponentCanvasFitAnimationMeasurer 
      clothingType={selectedOrderItemMeasurementObject?.clothingType ?? ClothingType.KemejaPanjang}
      fitType={selectedOrderItemMeasurementObject?.fitType ?? FitType.RegularFit}
      putAtTop={false}
      scaleRatio={scaleRatioNumber / 1000}
      aspectRatioNumber={aspectRatioNumber / 1000}
      incrementTogether={true}
      goalFit={RoundClothingMeasurementsToHalfPoint(CalculateClothingMeasurementsFromBodyMeasurements(
        selectedOrderItemMeasurementObject?.clothingType ?? ClothingType.KemejaPanjang, 
        selectedOrderItemMeasurementObject?.fitType ?? FitType.RegularFit,
        selectedOrderItemMeasurementObject?.userMeasurementsForItem?.adjustedMeasurements ? 
        selectedOrderItemMeasurementObject.userMeasurementsForItem.adjustedMeasurements :
        {
          panjangBaju: 81,
          lingkarDada: 142,
          lingkarPerut: 142,
          lingkarPinggul: 142,
          lingkarLeher: 41,
          lebarBahu: 57,
          lingkarLenganBisep: 31.25,
          panjangLenganPanjang: 62,
          lingkarLenganPergelangan: 19.4,
        }, RegularSizeValue.L))}
      drawGuidelinesData={undefined}
      />
    </Box>
  );
}